// extracted by css-extract-rspack-plugin
export default {"stickyHeader":"use-sticky-header-module__stickyHeader__sf0hv"};